<template>
  <div
    class="toast-container"
    id="notification-bus"
  >
    <Message
      :message="m"
      :key="id"
      v-for="[id, m] in stack.entries()"
      @close="onClose(id)"
    />
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useMessageStack } from '@provise/stores/messagestack'
import Message from './messagestack/message.vue'
const messageStack = useMessageStack()
const { stack } = storeToRefs(messageStack)

function onClose(id) {
  messageStack.close(id)
}
</script>
